<nav class="outpost-sidebar">
    <ul>
      <li class="outpost-sidebar-header">
        <span class="outpost-sidebar-header-label">outpost</span>
      </li>
      @for (item of items; track item.id)
      {
        <li class="outpost-sidebar-item"
            [ngClass]="{ active: isActive(item) }"
            (click)="onItemClick(item)">
          <div class="outpost-sidebar-icon-wrapper">
            <div
              class="outpost-sidebar-icon"
              [ngClass]="{ online: isOutpostOnline(item) }"
              inlineSVG="/assets/icons/listening.svg">
            </div>
          </div>
          <div>
            <span class="outpost-sidebar-item-label">{{ item.name }}</span>
          </div>
        </li>
      }
    </ul>
</nav>
